import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  professional_investor_concentration_rate: {
    name: 'Professional clients',
    order: 75,
    letter: 'A'
  },
  retail_investor_concentration_rate: {
    name: 'Retail investors',
    order: 76,
    letter: 'A'
  }
};

export function InvestorConcetration2({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_CONCENTRATION,
    onChangeFund,
    schema: schema.INVESTOR_CONCENTRATION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_CONCENTRATION?.field_names || [],
    tableName: 'INVESTOR_CONCENTRATION',
    columnLables,
    funds,
    isMultiFunds
  });
  return (
    <Table
      id="fca-reporttables-investor-concentration-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
